export const planesKeys = {
  all: ['planes'] as const,
  lists: () => [...planesKeys.all, 'list'] as const,
  list: (filters: Record<string, unknown>) => [...planesKeys.lists(), filters] as const,
  details: () => [...planesKeys.all, 'detail'] as const,
  detail: (id: number) => [...planesKeys.details(), id] as const,
};
